import { Sparkles, Twitter, Instagram, Youtube, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-muted/30">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="col-span-1 md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-cyan-500 flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-white" strokeWidth={2.2} />
            </div>
            <div>
              <div className="font-display text-xl font-black">Luminon</div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Building brighter minds</div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
            A premium learning ecosystem for grades 1–12. Chapter-organized notes, immersive video lessons,
            and verified tutors — reimagined for the way today's students actually learn.
          </p>
          <div className="flex items-center gap-2 mt-6">
            {[Twitter, Instagram, Youtube, Linkedin].map((Ic, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:scale-110 transition-transform">
                <Ic className="w-4 h-4" strokeWidth={1.8} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest font-semibold text-muted-foreground mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li>Notes</li><li>Learnings</li><li>Find Tutor</li><li>Book Demo</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest font-semibold text-muted-foreground mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li>About</li><li>Contact</li><li>Privacy</li><li>Terms</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-wrap items-center justify-between text-xs text-muted-foreground">
          <div>© 2026 Luminon. Learning meets the future.</div>
          <div>Crafted for curious minds worldwide.</div>
        </div>
      </div>
    </footer>
  );
}
